export default __webpack_public_path__ + "static/media/blog-1.722c880d.jpg";